import DriverListModal from './driverList';
import ISAEditModal from './isaEdit';
import CTNEditModal from './ctnEdit';
import ShippingStatusEditModal from './shippingStatusEdit';
import Notes from './Notes';
import LocationChange from './LocationChange';
import InboundDateChange from './InboundDateChange';
import BatchesModal from './BatchesModal';
import PromotionAddingModal from './PromotionAddingModal';
import PromotionsModal from './PromotionsModal';
import ApplyPromotionsModal from './ApplyPromotionsModal'
import TeapplixResyncModal from './TeapplixResyncModal'
import StuffResyncModal from './StuffResyncModal'
import MissingSKUsModal from './MissingSKUsModal';
import MonitorNoteModal from './MonitorNoteModal';
import MonitorRemoveModal from './MonitorRemoveModal';
import MonitorListModal from './MonitorListModal';
import ApplyPromotionsModal2 from './ApplyPromotionsModal2';
import ApplyPromotionsModal3 from './ApplyPromotionsModal3';
import UnqualifyProductPromotionModal from './UnqualifyProductPromotionModal';
import ShippingRateModal from './ShippingRateModal';
import CreateExcelModal from './CreateExcelModal';

import { ShippingStatusEditModalForSalesQuoteWithRedux as ShippingStatusEditModalForSalesQuote } from './shippingStatusEdit/Modal';

const salesOrderModals = {
  DriverListModal,
  ISAEditModal,
  CTNEditModal,
  ShippingStatusEditModal,
  ShippingStatusEditModalForSalesQuote,
  Notes,
  LocationChange,
  InboundDateChange,
  BatchesModal,
  PromotionAddingModal,
  PromotionsModal,
  ApplyPromotionsModal,
  TeapplixResyncModal,
  StuffResyncModal,
  MissingSKUsModal,
  MonitorNoteModal,
  MonitorRemoveModal,
  MonitorListModal,
  ApplyPromotionsModal2,
  ApplyPromotionsModal3,
  UnqualifyProductPromotionModal,
  ShippingRateModal,
  CreateExcelModal,
}

export default salesOrderModals;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/index.jsx